import React from 'react';
import * as Icons from 'lucide-react';
import featuresData from '../data/features.json';
import PageHero from '../components/PageHero';
import GlassCard from '../components/GlassCard';

const Features = () => {
  return (
    <div className="relative">
      <PageHero 
        title={featuresData.pageTitle}
        subtitle={featuresData.pageSubtitle}
      />

      {/* Feature Categories */}
      {featuresData.categories.map((category, catIndex) => (
        <section 
          key={category.id}
          className={`section-padding ${catIndex % 2 === 1 ? 'cosmic-bg' : ''}`}
          data-testid={`feature-category-${category.id}`}
        >
          <div className="max-w-7xl mx-auto">
            <div className="mb-12">
              <span className="text-sm font-mono tracking-widest uppercase text-violet-400 mb-4 block">
                0{catIndex + 1}
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {category.title}
              </h2>
              <p className="text-slate-400 text-lg max-w-2xl">
                {category.description}
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {category.features.map((feature, index) => (
                <GlassCard
                  key={index}
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                  data-testid={`feature-card-${category.id}-${index}`}
                />
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to experience cognitive AI?
          </h2>
          <p className="text-slate-400 text-lg mb-8">
            Join the early access list and be among the first to try ROMIND.
          </p>
          <a 
            href="/#early-access" 
            className="btn-primary text-lg px-10 py-4"
            data-testid="features-cta"
          >
            Get Early Access
          </a>
        </div>
      </section>
    </div>
  );
};

export default Features;
